enum ContractType {
  PERSONAL = 0,
  BUSINESS = 1,
  CORPORATION = 2,
}

export const allCases = [ContractType.PERSONAL, ContractType.BUSINESS, ContractType.CORPORATION];

export const name = (type: ContractType | undefined | null) => {
  switch (type) {
    case ContractType.PERSONAL:
      return '개인';
    case ContractType.BUSINESS:
      return '개인 사업자';
    case ContractType.CORPORATION:
      return '법인 사업자';
    default:
      return '';
  }
};

export default ContractType;
